export const environment = {
  production: true,
  debug: true,
  googleMapsApiKey: 'AIzaSyCYe7gJzo1Sc3OBqsZq1WV1bNDxF0gcCyk',
};
